import React from 'react'
import cn from 'classnames'
import { useTranslation } from '@mc/i18n'
import appearanceClasses from 'pages/find-my-classes/components/common/appearance.module.scss'
import { QuizMachineContext } from '../../context'

export const InteractiveStep = ({
  children,
  title,
  showHeader = false,
  animateOut = false,
  inAnimation = false,
}: {
  children: React.ReactNode
  title?: string | React.ReactElement
  hideBackButton?: boolean
  showHeader?: boolean
  animateOut?: boolean
  inAnimation?: boolean
}) => (
  <div
    className={cn('mc-pt-7', {
      [appearanceClasses.disappearing]: animateOut && inAnimation,
    })}
  >
    {showHeader && <InteractiveStepHeader />}
    <div className='row no-gutters-vertical justify-content-center'>
      <div className='col-12 col-md-8 mc-text--center'>
        <div className='mc-mt-2'>
          {title ? <h1 className='mc-text-h4'>{title}</h1> : null}
        </div>
        <div>{children}</div>
      </div>
    </div>
  </div>
)

const InteractiveStepHeader = () => {
  const { t } = useTranslation('@mc/next')

  const { step, totalSteps } = QuizMachineContext.useSelector(
    ({ context }) => ({
      step: context.step,
      totalSteps: context.totalSteps,
    }),
  )

  return (
    <div>
      <p className='mc-text-medium mc-text--center mc-opacity--muted'>
        <span className='mc-sr-only'>
          {t('findMyClasses.quizHeader.a11y.title', {
            currentQuestion: step,
            questionCount: totalSteps,
          })}
        </span>
        <span aria-hidden>
          {step}/{totalSteps}
        </span>
      </p>
    </div>
  )
}
